<template>
  <div
    class="border rounded p-5"
    v-for="(item, index) in items"
    :key="item.pr_item_id"
  >
    <div class="font-bold text-xl mb-4">ลำดับที่ {{ index + 1 }}.</div>
    <div
      class="grid grid-cols-1 lg:grid-cols-3 space-y-2 lg:space-y-0 lg:gap-4"
    >
      <!-- col-1 -->
      <div class="col-span-2">
        <div class="text-lg font-bold">รายละเอียดสินค้า</div>

        <div class="mb-2">
          <div class="font-bold">รายการสินค้า:</div>
          <div
            v-html="
              item.item_name ? item.item_name.replaceAll('\n', '<br>') : ''
            "
          ></div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 md:gap-4">
          <div>
            <div class="flex justify-between">
              <div class="font-bold">หมวดหมู่สินค้า:</div>
              <div>{{ item.item_category }}</div>
            </div>
            <div class="flex justify-between">
              <div class="font-bold">รหัสชนิดสินค้า:</div>
              <div>{{ item.item_code }}</div>
            </div>

            <div class="flex justify-between">
              <div class="font-bold">หน่วยนับ:</div>
              <div>{{ item.uom }}</div>
            </div>
            <div class="flex justify-between">
              <div class="font-bold">วันที่ต้องการใช้:</div>
              <div>{{ item.use_date }}</div>
            </div>
            <div class="">
              <div class="font-bold">สถานที่รับสินค้า:</div>
              <div>{{ item.pickup_loc }}</div>
            </div>
          </div>
          <!-- col-2 -->
          <div>
            <div class="flex justify-between">
              <div class="font-bold">ราคาต่อหน่วย:</div>
              <div>{{ numberFormat(item.unit_price) }}</div>
            </div>
            <div class="flex justify-between">
              <div class="font-bold">จำนวนหน่วย:</div>
              <div>{{ numberFormat(item.qty) }}</div>
            </div>
            <div class="flex justify-between">
              <div class="font-bold">ราคาก่อนภาษี:</div>
              <div>{{ numberFormat(item.amount) }}</div>
            </div>
            <div
              v-if="
                !(props.isPermissionVat && props.isApprove && !props.isClaim)
              "
            >
              <div class="flex justify-between">
                <div class="font-bold">
                  เงินประกันผลงาน
                  {{
                    item.retention_rate > 0 ? `${item.retention_rate}%:` : ':'
                  }}
                </div>
                <div>{{ numberFormat(item.retention) }}</div>
              </div>
              <div class="flex justify-between">
                <div class="font-bold">
                  ภาษีมูลค่าเพิ่ม {{ item.vat_rate }}%:
                </div>
                <div>{{ numberFormat(item.vat) }}</div>
              </div>
              <div class="flex justify-between">
                <div class="font-bold">
                  ภาษีหัก ณ ที่จ่าย {{ item.wh_tax_rate }}%:
                </div>
                <div>{{ numberFormat(item.wh_tax) }}</div>
              </div>
              <div class="flex justify-between">
                <div class="font-bold">Actual Cost:</div>
                <div>{{ numberFormat(item.actual_cost) }}</div>
              </div>
            </div>
            <div class="space-y-4" v-else-if="newItems.length">
              <div class="">
                <label for="" class="form-label font-bold"
                  >เงินประกันผลงาน:</label
                >
                <div class="grid grid-cols-4 space-x-2">
                  <input
                    type="number"
                    class="form-control col-span-2"
                    min="0"
                    v-model.number="newItems[index].retention"
                    @keyup="calRetention(index)"
                    @change="calRetention(index)"
                    :disabled="!newItems[index].retentionProcess"
                  />
                  <input
                    type="number"
                    class="form-control"
                    v-model.number="newItems[index].retention_rate"
                    min="0"
                    max="100"
                    @keyup="calRetentionProcess(index)"
                    @change="calRetentionProcess(index)"
                  />
                  <button
                    class="btn"
                    :class="[
                      newItems[index].retentionProcess
                        ? 'btn-primary'
                        : 'btn-secondary'
                    ]"
                    @click="
                      ;[
                        (newItems[index].retentionProcess = !newItems[index]
                          .retentionProcess),
                        calRetentionProcess(index)
                      ]
                    "
                  >
                    คำนวณ
                  </button>
                </div>
              </div>
              <div class="">
                <label for="" class="form-label font-bold"
                  >ภาษีมูลค่าเพิ่ม:</label
                >
                <div class="grid grid-cols-4 space-x-2">
                  <input
                    type="number"
                    class="form-control col-span-2"
                    min="0"
                    v-model.number="newItems[index].vat"
                    @keyup="calVat(index)"
                    @change="calVat(index)"
                    :disabled="!newItems[index].taxVatProcess"
                  />
                  <input
                    type="number"
                    class="form-control"
                    v-model.number="newItems[index].vat_rate"
                    min="0"
                    max="100"
                    @keyup="calVatProcess(index)"
                    @change="calVatProcess(index)"
                  />
                  <button
                    class="btn"
                    :class="[
                      newItems[index].taxVatProcess
                        ? 'btn-primary'
                        : 'btn-secondary'
                    ]"
                    @click="
                      ;[
                        (newItems[index].taxVatProcess = !newItems[index]
                          .taxVatProcess),
                        calVatProcess(index)
                      ]
                    "
                  >
                    คำนวณ
                  </button>
                </div>
              </div>
              <div class="">
                <label for="" class="form-label font-bold"
                  >ภาษีหัก ณ ที่จ่าย:</label
                >
                <div class="grid grid-cols-4 space-x-2">
                  <input
                    type="number"
                    class="form-control col-span-2"
                    min="0"
                    v-model.number="newItems[index].wh_tax"
                    @keyup="calTax(index)"
                    @change="calTax(index)"
                    :disabled="!newItems[index].taxWhProcess"
                  />
                  <input
                    type="number"
                    class="form-control"
                    v-model.number="newItems[index].wh_tax_rate"
                    min="0"
                    max="100"
                    @keyup="calTaxProcess(index)"
                    @change="calTaxProcess(index)"
                  />
                  <button
                    class="btn"
                    :class="[
                      newItems[index].taxWhProcess
                        ? 'btn-primary'
                        : 'btn-secondary'
                    ]"
                    @click="
                      ;[
                        (newItems[index].taxWhProcess = !newItems[index]
                          .taxWhProcess),
                        calTaxProcess(index)
                      ]
                    "
                  >
                    คำนวณ
                  </button>
                </div>
              </div>
              <div class="flex justify-between">
                <div class="font-bold">Actual Cost:</div>
                <div>{{ numberFormat(newItems[index].actual_cost) }}</div>
              </div>
              <div>
                <button
                  class="btn btn-warning"
                  @click="updateItemActualCost(index)"
                >
                  อัพเดท
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- col-3 -->
      <div>
        <div class="text-lg font-bold">รายละเอียดงบประมาณ</div>
        <!-- ปีงบประมาณ -->
        <div class="flex justify-between">
          <div class="font-bold">
            ปีงบประมาณ:
          </div>
          <div>{{ item.budget_year }}</div>
        </div>
        <!-- ชนิดงบประมาณ -->
        <div class="flex justify-between">
          <div class="font-bold">
            ชนิดงบประมาณ:
          </div>
          <div>
            {{ item.budget_subledger ? 'งบประมาณโครงการ' : 'งบประมาณหน่วยงาน' }}
          </div>
        </div>
        <!-- ใช้งบประมาณของหน่วยงาน -->
        <div class="flex justify-between">
          <div class="font-bold">
            ใช้งบประมาณของหน่วยงาน:
          </div>
          <div>
            {{ item.budget_bu_name }}
          </div>
        </div>
        <!-- รหัส BU -->
        <div class="flex justify-between">
          <div class="font-bold">
            รหัส BU:
          </div>
          <div>
            {{ item.budget_bu_code }}
          </div>
        </div>
        <!-- account code -->
        <div class="flex justify-between">
          <div class="font-bold">
            Account Code:
          </div>
          <div>
            {{ item.budget_code }}
          </div>
        </div>
        <!-- account name -->
        <div class="flex justify-between">
          <div class="font-bold">
            Subsidiary:
          </div>
          <div>
            {{ item.budget_subsidiary }}
          </div>
        </div>
        <!-- account name -->
        <div class="flex justify-between">
          <div class="font-bold">
            Account Name:
          </div>
          <div>
            {{ item.budget_name }}
          </div>
        </div>
        <!-- Subledger -->
        <div class="flex justify-between">
          <div class="font-bold">
            Subledger:
          </div>
          <div>
            {{ item.budget_subledger }}
          </div>
        </div>
        <!-- Subledger Name -->
        <div class="flex justify-between">
          <div class="font-bold">
            Subledger Name:
          </div>
          <div>
            {{ item.budget_subledger_name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch } from 'vue'
import { useStore } from '@/store'
import helpers from '@/helpers'
import alert from '@/helpers/alert'
import { api } from '@/utils/api'

export default defineComponent({
  name: 'table-item-gr',
  props: {
    items: Array,
    isPermissionVat: {
      type: Boolean,
      default: () => false
    },
    isApprove: {
      type: Boolean,
      default: () => false
    },
    isClaim: {
      type: Boolean,
      default: () => false
    },
    analysisCodeOption1: {
      type: Array,
      default: () => []
    },
    analysisCodeOption2: {
      type: Array,
      default: () => []
    },
    analysisCodeOption9: {
      type: Array,
      default: () => []
    },
    analysisCodeOption10: {
      type: Array,
      default: () => []
    }
  },
  setup(props) {
    const store = useStore()
    // const taxRateOptions = computed(() => store.state.global.taxRate)
    // const catCodeOptions = computed(() => store.state.global.catCode)

    const newItems = ref([...props.items])

    watch(
      () => props.items,
      newVal => {
        newItems.value = [...newVal]
      }
    )

    // console.log('newItem:', newItems)

    // const getTaxRate = taxRate => {
    //   if (taxRate) {
    //     const rate = taxRateOptions.value.find(
    //       item => item.tax_code === taxRate
    //     )
    //     if (rate) {
    //       return `${rate.tax_code} - ${rate.tax_name}`
    //     } else {
    //       return 'ข้อมูลไม่ตรงกัน'
    //     }
    //   } else {
    //     return 'ไม่ระบุ'
    //   }
    // }

    // const getCatCode = catCode => {
    //   if (catCode !== null) {
    //     const code = catCodeOptions.value.find(
    //       item => item.cat_code === catCode
    //     )
    //     if (code) {
    //       return `${code.cat_code} - ${code.cat_name}`
    //     } else {
    //       return 'ข้อมูลไม่ตรงกัน'
    //     }
    //   } else {
    //     return 'ไม่ระบุ'
    //   }
    // }

    // const updateItemVat = async index => {
    //   // if (props.items[index].vat > 0 && props.items[index].tax_rate == null) {
    //   //   alert.error('กรุณาเลือก Tax Rate')
    //   //   return
    //   // }
    //   const updateVat = {
    //     // cat_code: props.items[index].cat_code,
    //     // tax_rate: props.items[index].tax_rate,
    //     // gl_offset: props.items[index].gl_offset
    //     // analysis_code_1: props.items[index].analysis_code_array.analysis_code_1,
    //     // analysis_code_2: props.items[index].analysis_code_array.analysis_code_2,
    //     // analysis_code_9: props.items[index].analysis_code_array.analysis_code_9,
    //     // analysis_code_10:
    //     //   props.items[index].analysis_code_array.analysis_code_10,
    //     // asset_code: props.items[index].asset_code,
    //     // asset_indicator: props.items[index].asset_indicator
    //   }
    //   await api
    //     .put(
    //       `${process.env.VUE_APP_API_URL}/procurement/gr/updateItemVat/${props.items[index].gr_item_id}`,
    //       updateVat
    //     )
    //     .then(res => {
    //       if (res.code == 200) {
    //         alert.success()
    //       } else {
    //         alert.error(res.message)
    //       }
    //     })
    //     .catch(e => {
    //       alert.error(e.message)
    //     })
    // }

    const calRetention = i => {
      newItems.value[i].actual_cost =
        newItems.value[i].amount +
        newItems.value[i].vat -
        newItems.value[i].wh_tax -
        newItems.value[i].retention
    }

    const calVat = i => {
      newItems.value[i].actual_cost =
        newItems.value[i].amount +
        newItems.value[i].vat -
        newItems.value[i].wh_tax -
        newItems.value[i].retention
    }

    const calTax = i => {
      newItems.value[i].actual_cost =
        newItems.value[i].amount +
        newItems.value[i].vat -
        newItems.value[i].wh_tax -
        newItems.value[i].retention
    }

    const calRetentionProcess = i => {
      if (newItems.value[i].retentionProcess) {
        if (
          newItems.value[i].retention_rate > 0 &&
          newItems.value[i].retention_rate <= 100
        ) {
          newItems.value[i].retention =
            (newItems.value[i].amount * newItems.value[i].retention_rate) / 100
        } else {
          newItems.value[i].retention = 0
        }
      } else {
        newItems.value[i].retention = 0
      }
      calVat(i)
    }

    const calVatProcess = i => {
      if (newItems.value[i].taxVatProcess) {
        if (
          newItems.value[i].vat_rate > 0 &&
          newItems.value[i].vat_rate <= 100
        ) {
          newItems.value[i].vat =
            (newItems.value[i].amount * newItems.value[i].vat_rate) / 100
        } else {
          newItems.value[i].vat = 0
        }
      } else {
        newItems.value[i].vat = 0
      }
      calVat(i)
    }

    const calTaxProcess = i => {
      if (newItems.value[i].taxWhProcess) {
        if (
          newItems.value[i].wh_tax_rate > 0 &&
          newItems.value[i].wh_tax_rate <= 100
        ) {
          newItems.value[i].wh_tax =
            (newItems.value[i].amount * newItems.value[i].wh_tax_rate) / 100
        } else {
          newItems.value[i].wh_tax = 0
        }
      } else {
        newItems.value[i].wh_tax = 0
      }
      calTax(i)
    }

    const calActualCost = i => {
      newItems.value[i].actual_cost =
        newItems.value[i].amount +
        newItems.value[i].vat -
        newItems.value[i].wh_tax -
        newItems.value[i].retention
    }

    const updateItemActualCost = async i => {
      const data = {
        vat_rate: newItems.value[i].vat_rate,
        vat: newItems.value[i].vat,
        wh_tax_rate: newItems.value[i].wh_tax_rate,
        wh_tax: newItems.value[i].wh_tax,
        actual_cost: newItems.value[i].actual_cost,
        retention: newItems.value[i].retention,
        retention_rate: newItems.value[i].retention_rate
      }
      await api
        .put(
          `${process.env.VUE_APP_API_URL}/procurement/gr/updateItemExpenses/${newItems.value[i].gr_item_id}`,
          data
        )
        .then(res => {
          if (res.code == 200) {
            alert.success()
          } else {
            alert.error(res.message)
          }
        })
        .catch(e => {
          alert.error(e.message)
        })
    }

    const { numberFormat } = helpers

    const getAnalysisCodeText = code => {
      return store.getters['global/getAnalysisCodeText'](code)
    }

    onMounted(async () => {
      // store.dispatch('global/loadTaxRate')
      // store.dispatch('global/loadCatCode')
      // store.dispatch('global/loadOptionAnalysisCode')
    })
    return {
      props,
      numberFormat,
      // getTaxRate,
      // getCatCode,
      calVat,
      calTax,
      calActualCost,
      calVatProcess,
      calTaxProcess,
      newItems,
      updateItemActualCost,
      // updateItemVat,
      // taxRateOptions,
      // catCodeOptions,
      getAnalysisCodeText,
      calRetention,
      calRetentionProcess
    }
  }
})
</script>
